import React from 'react';
import TopologyBox, { TopologyBoxProps } from './topologyBox';
import { Box } from '@mui/material';
import './dotsAnimation.css';
import TopologyFlow, { TopologyFlowProps } from './topologyFlow';

interface TopologyColumnProps {
  topBox?: TopologyBoxProps;
  centerBox?: TopologyBoxProps;
  bottomBox?: TopologyBoxProps;
  topConnection?: TopologyFlowProps;
  centerConnection?: TopologyFlowProps;
  bottomConnection?: TopologyFlowProps;
  isLast: boolean;
  isFirst: boolean;
}

function TopologyColumn(props: TopologyColumnProps) {
  const isMobile = window.innerWidth <= 1490;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        marginLeft: props.isFirst ? '0px' : isMobile ? '52px' : '68px',
        // Phone: keep natural width inside the scrollable row (no crushing).
        // Desktop (>=md) keeps the default flex-shrink, so layout is unchanged.
        flexShrink: { xs: 0, md: 1 }
      }}
    >
      <TopologyBox {...props.topBox}></TopologyBox>

      {props.topBox && props.centerBox && (
        <TopologyFlow {...props.topConnection} />
      )}
      <TopologyBox {...props.centerBox}></TopologyBox>
      {!props.isLast && <TopologyFlow {...props.centerConnection} />}

      {props.centerBox && props.bottomBox && (
        <TopologyFlow {...props.bottomConnection} />
      )}
      <TopologyBox {...props.bottomBox}></TopologyBox>
    </Box>
  );
}

export default TopologyColumn;
